import * as commonSchema from '../../Common/js/normalizr.schema'

const Schema = {
  ...commonSchema.default,
};

export default Schema;
